var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.5 0.5C0.5 0.367392 0.552678 0.240215 0.646447 0.146447C0.740215 0.0526784 0.867392 0 1 0H13C13.1326 0 13.2598 0.0526784 13.3536 0.146447C13.4473 0.240215 13.5 0.367392 13.5 0.5V2.5C13.5 2.62331 13.4544 2.74226 13.372 2.834L9 7.692V12.5C8.99992 12.6049 8.96685 12.7071 8.90547 12.7922C8.8441 12.8772 8.75752 12.9409 8.658 12.974L5.658 13.974C5.58287 13.999 5.50288 14.0058 5.4246 13.9939C5.34632 13.982 5.272 13.9516 5.20775 13.9053C5.1435 13.859 5.09116 13.7982 5.05504 13.7277C5.01893 13.6572 5.00006 13.5792 5 13.5V7.692L0.628 2.834C0.545608 2.74226 0.500022 2.62331 0.5 2.5V0.5ZM1.5 1V2.308L5.872 7.166C5.95439 7.25774 5.99998 7.37669 6 7.5V12.806L8 12.14V7.5C8.00002 7.37669 8.04561 7.25774 8.128 7.166L12.5 2.308V1H1.5Z",
    fill: "#0D0D0D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.882c2f5175d1004d9776ed6953b33fc1.svg";
export { ForwardRef as ReactComponent };